export default __webpack_public_path__ + "static/media/money-changer-pic1.20a667c2.png";